import { lazy, Suspense } from "react";
import LoadingScreen from "../components/loading-screen";
// components

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
};

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));

export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// TODO: general section
export const LandingPage = Loadable(
  lazy(() => import("../pages/general/Dashboard"))
);

// TODO: my profile

export const MyProfile = Loadable(
  lazy(() => import("../pages/myProfile/MyProfile"))
);

export const Services = Loadable(
  lazy(() => import("../pages/service/Service"))
);

export const Banner = Loadable(lazy(() => import("../pages/banner/Banner")));
export const EventBooking = Loadable(
  lazy(() => import("../pages/eventbooking/EventBooking"))
);

export const Service = Loadable(lazy(() => import("../pages/service/Service")));
export const News = Loadable(lazy(() => import("../pages/news/News")));

export const Event = Loadable(lazy(() => import("../pages/event/Event")));
export const EventType = Loadable(
  lazy(() => import("../pages/eventtype/EventType"))
);

export const EventGallery = Loadable(
  lazy(() => import("../pages/eventGallery/EventGallery"))
);

export const BookingList = Loadable(
  lazy(() => import("../pages/booking/Booking"))
);

export const OverView = Loadable(lazy(() => import("../pages/overview/index")));

export const RoomType = Loadable(lazy(() => import("../pages/roomType/index")));
export const RoomBooking = Loadable(
  lazy(() => import("../pages/roomBooking/index"))
);

export const HotelRoom = Loadable(
  lazy(() => import("../pages/hotelRoom/index"))
);
export const RoomRate = Loadable(lazy(() => import("../pages/roomrate/index")));

export const Package = Loadable(lazy(() => import("../pages/package/index")));
